<header class="page_header">
    <div class="header_content">
      <div class="text_and_supporting_text">
        <div class="page_title">Equipment Master</div>
      </div>
      <div class="action_btn">
        <button class="add_new_btn" (click)="addEquipment()">
          <img src="assets/icons/plus_icon.svg" height="20" width="20">Add New
        </button>
      </div>
    </div>
  </header>
  
  <div class="search_bar_action_btns">
    <div class="container">

      
      <div class="bulk_actions">
        @if (selectedItems.length > 0 || allTableRecordsSelected) {
        <div class="selection_count">
          <div class="count">
            {{
            allTableRecordsSelected
            ? tableStats.total
            : selectedItems.length
            }}
            selected
          </div>
        </div>
        <div class="actions">
          <button class="tick" (click)="bulkActionConfirmation('setActive')">Make Banks Active</button>
          <button class="close" (click)="bulkActionConfirmation('setInActive')">Make Banks Inactive</button>
        </div>
        }
      </div>
      </div>
      </div>


  <app-tos-table
  [stats]="tableStats"
  [showTableStats]="true"
  [tableMeta]="tableMeta"
  [filterConfig]="equipmentMasterMetaConfig.filterConfig"
  [searchBarConfig]="equipmentMasterMetaConfig.searchBarConfig"
  [tableMenuOptions]="menuOptions"
  [(dataListRequest)]="tableListRequest"
  [dataListResponse]="tableListData"
  [(selectedItems)]="selectedItems"
  (tosTableAction)="fetchAllRecords()"
  (tableMenuOptionSelected)="handleOptionSelected($event)"
></app-tos-table>